/*
This file is for handle Recorder.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date	: 07/12/2017 12:05 PM
*/
/* global document */

import Element from './../Element';
import View from './../View';
import Room from './../../Room';
import DefaultSkin from '../assets/css/defaultCss';

const Play = (spec) => {
    const view = View({});
    const that = {};
    that.stream = spec.stream;
    if (spec.skin === 'default') {
        that.play = Element({
            name: 'i',
            title: 'pause',
            class: 'fa fa-pause fa-lg icon_play',
            style: Object.assign(DefaultSkin.icon, DefaultSkin.icon_play),
        });
    } else {
        that.play = Element({
            name: 'i',
            title: 'pause',
            class: `fa fa-pause fa-lg ${spec.skin}_icon icon_play ${spec.skin}_icon_play`,
        });
    }
    that.play.onclick = function (e) {
        Play.click(e);
    };
    const css = Element.getCss;
    return that.play;
};

Play.toggleVideo = (video) => {
    video.srcObject.getTracks().forEach(t => t.enabled = !t.enabled);
};
Play.click = function (e) {
    const className = e.currentTarget.classList;
    if (className.contains('fa-pause')) {
        e.currentTarget.classList.remove('fa-pause');
        e.currentTarget.classList.add('fa-play');
        var playerDiv = e.currentTarget.parentNode.parentNode.parentNode;
        var videoTag = Element.getById(`stream${playerDiv.id.split('_')[1]}`);
        var screenSaver = Element.getById(`screen_saver_${playerDiv.id.split('_')[1]}`);
        Play.toggleVideo(videoTag);
        if (screenSaver.src !== '') { screenSaver.style.display = 'block'; } else { videoTag.pause(); }
    } else if (className.contains('fa-play')) {
        e.currentTarget.classList.remove('fa-play');
        e.currentTarget.classList.add('fa-pause');
        var playerDiv = e.currentTarget.parentNode.parentNode.parentNode;
        var videoTag = Element.getById(`stream${playerDiv.id.split('_')[1]}`);
        var screenSaver = Element.getById(`screen_saver_${playerDiv.id.split('_')[1]}`);
        Play.toggleVideo(videoTag);
        if (screenSaver.src !== '') { screenSaver.style.display = 'none'; } else { videoTag.play(); }
    }
};

export default Play;



//////////////////
// WEBPACK FOOTER
// ./src/views/component/Play.js
// module id = 186
// module chunks = 0